import post, { get, put, deleteAction } from './base-service';
import API_HELPER from '../constants/api-urls';
import _ from 'lodash';

export const badgesListData = async (requestData) => {
  try {
    let url = `${API_HELPER.URL.badgesList}?page_size=${requestData.page_size}&page=${requestData.page_index}`;
    if (!_.isEmpty(requestData.status)) {
      url += `&status=${requestData.status}`;
    }
    if (!_.isEmpty(requestData.search)) {
      url += `&search=${requestData.search}`;
    }
    if (!_.isEmpty(requestData.ordering)) {
      url += `&ordering=${requestData.ordering}`;
    }
    const response = await get(url);
    return response;
  } catch (error) {
    console.log('badgesListData service catch-----------------', error);
    return error;
  }
};

export const badgesAction = async (id, requestData) => {
  try {
    const response = await post(
      `${API_HELPER.URL.badgesList}${id}/update_status/`,
      requestData
    );
    return response;
  } catch (error) {
    console.log('badgesAction service catch-----------------', error);
    return error;
  }
};

export const updateBadgeSequence = async (id, sequence) => {
  try {
    const response = await post(
      `${API_HELPER.URL.badgesList}${id}/update_badge_sequence/`,
      { sequence }
    );
    return response;
  } catch (error) {
    console.log('updateBadgeSequence service catch-----------------', error);
    return error;
  }
};

export const addBadge = async (requestData) => {
  try {
    const response = await post(`${API_HELPER.URL.badgesList}`, requestData);
    return response;
  } catch (error) {
    console.log('addBadge service catch-----------------', error);
    return error;
  }
};

export const updateBadge = async (id, requestData) => {
  try {
    const response = await put(
      `${API_HELPER.URL.badgesList}${id}/`,
      requestData
    );
    return response;
  } catch (error) {
    console.log('updateBadge service catch-----------------', error);
    return error;
  }
};

export const getBadgeById = async (id) => {
  try {
    const response = await get(`${API_HELPER.URL.badgesList}${id}/`);
    return response;
  } catch (error) {
    console.log('getBadgeById service catch-----------------', error);
    return error;
  }
};

export const deleteBadge = async (id) => {
  try {
    const response = await deleteAction(`${API_HELPER.URL.badgesList}${id}/`);
    return response;
  } catch (error) {
    console.log('deleteBadge service catch-----------------', error);
    return error;
  }
};

export const getBadgesCategory = async () => {
  try {
    const response = await get(`${API_HELPER.URL.badgesCategory}`);
    return response;
  } catch (error) {
    console.log('getBadgesCategory service catch-----------------', error);
    return error;
  }
};

export const getBadgeCategoryById = async (id) => {
  try {
    const response = await get(
      `${API_HELPER.URL.badgesCategoryById.replace(':id', id)}`
    );
    return response;
  } catch (error) {
    console.log('getBadgeCategoryById service catch-----------------', error);
    return error;
  }
};
